/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  MdOutlineArrowBackIos,
  MdOutlineArrowForwardIos,
  MdUpload,
} from 'react-icons/md';
import { format, parseISO } from 'date-fns';
import { IoMdClose, IoMdDownload } from 'react-icons/io';
import { Form } from '@unform/web';
import { HiPlus } from 'react-icons/hi';
import { FaRegFilePdf } from 'react-icons/fa6';
import Swal from 'sweetalert2';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import getValidationErros from '~/utils/getValidationsErrors';
import api from '~/services/api';
import { useResize } from '~/hooks/Resize';
import Toast from '~/utils/toast';

import { Container, Filter, Modal, Pagination } from './styles';
import FiltersLists from '~/components/FiltersLists';
import {
  KrClose,
  KrEye,
  KrInfo,
  KrTrash,
  KrUserDocument,
} from '~/components/KoroIcons';
import Input from '~/components/Input';
import Textarea from '~/components/Textarea';

interface IArchiveData {
  id: number;
  name: string;
  description: string;
  size: string;
  created_at: string;
  archive_url: string;
}

interface IArchiveResponse {
  data: IArchiveData[];
  from: number;
  to: number;
  total: number;
  pages: number;
}

interface IDocument {
  id: number;
  name: string;
  date: string;
  description: string;
  fileSize: string;
  url: string;
}

const Withdrawal: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { width } = useResize();
  const [files, setFiles] = useState<File[]>([]);

  const [show, setShow] = useState(false);
  const [showView, setShowView] = useState(false);
  const [urlDoc, setUrlDoc] = useState('');
  const [nameDoc, setNameDoc] = useState('');
  const [description, setDescription] = useState('');
  const [documents, setDocuments] = useState<IDocument[]>([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filenameData, setFilenameData] = useState('');

  const handleLoadFiles = useCallback(async (page, filename?: string) => {
    const response = await api.get<IArchiveResponse>('archives/admin', {
      params: {
        page,
        folder: 'documents',
        filename,
      },
    });

    const documentsData = response.data.data.map<IDocument>((archive) => ({
      id: archive.id,
      name: archive.name,
      description: archive.description,
      date: format(parseISO(archive.created_at), 'dd/MM/yyyy'),
      fileSize: archive.size,
      url: archive.archive_url,
    }));

    setTotalPages(response.data.pages);
    setDocuments(documentsData);
  }, []);

  useEffect(() => {
    handleLoadFiles(1);
  }, [handleLoadFiles]);

  useEffect(() => {
    const pagesArr: number[] = [];
    for (let i = 1; i <= totalPages; i += 1) {
      pagesArr.push(i);
    }
  }, [totalPages]);

  const pages = useMemo(() => {
    const pageSelected = selectedPage || 1;
    const qtd = width > 992 ? 7 : 5;
    const pageArray = Array.from(
      { length: totalPages < qtd ? totalPages : qtd },
      (e, index) => (totalPages < qtd ? `${index + 1}`.padStart(2, '0') : e)
    );

    const pageData = pageArray.map((page, index) => {
      if (page) {
        return page;
      }

      if (width > 992) {
        if (index === 0) {
          return '01';
        }
        if (index === 1) {
          if (pageSelected > 3 && pageSelected - 3 !== 1) {
            return '...';
          }
          return (2).toString().padStart(2, '0');
        }
        if (index === 2) {
          if (pageSelected > 3) {
            if (pageSelected + 3 > totalPages) {
              return (totalPages - 4).toString().padStart(2, '0');
            }
            return (pageSelected - 1).toString().padStart(2, '0');
          }
          return (3).toString().padStart(2, '0');
        }
        if (index === 3) {
          if (pageSelected > 4) {
            if (pageSelected + 3 > totalPages) {
              return (totalPages - 3).toString().padStart(2, '0');
            }
            return pageSelected.toString().padStart(2, '0');
          }
          return (4).toString().padStart(2, '0');
        }
        if (index === 4) {
          if (pageSelected >= 5) {
            if (pageSelected + 3 > totalPages) {
              return (totalPages - 2).toString().padStart(2, '0');
            }
            return (pageSelected + 1).toString().padStart(2, '0');
          }
          return (5).toString().padStart(2, '0');
        }
        if (index === 5) {
          if (pageSelected + 3 >= totalPages) {
            return (totalPages - 1).toString().padStart(2, '0');
          }
          return '...';
        }
        if (index === 6) {
          return totalPages.toString().padStart(2, '0');
        }
      } else {
        if (index === 0) {
          return (1).toString().padStart(2, '0');
        }
        if (index === 1) {
          if (pageSelected > 3) {
            return '...';
          }
          return (2).toString().padStart(2, '0');
        }
        if (index === 2) {
          if (pageSelected > 3 && pageSelected + 2 < totalPages) {
            return pageSelected.toString().padStart(2, '0');
          }
          if (pageSelected + 2 >= totalPages) {
            return (totalPages - 2).toString().padStart(2, '0');
          }
          return (3).toString().padStart(2, '0');
        }
        if (index === 3) {
          if (pageSelected + 2 >= totalPages) {
            return (totalPages - 1).toString().padStart(2, '0');
          }
          return '...';
        }
        if (index === 4) {
          return totalPages.toString().padStart(2, '0');
        }
      }

      return '';
    });

    return pageData as string[];
  }, [selectedPage, totalPages, width]);

  const handleDeleteDocument = useCallback((document) => {
    Swal.fire({
      icon: 'warning',
      iconColor: '#ff6900',
      title: 'Excluir documento',
      showCancelButton: true,
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim',
      confirmButtonColor: '#ff6900',
      cancelButtonColor: '#B34A00',
      reverseButtons: true,
    }).then(async (e) => {
      if (e.isConfirmed) {
        await api.delete(`archives/admin/${document.id}`);

        setDocuments((prevDoc) =>
          prevDoc.filter((doc) => doc.id !== document.id)
        );
        Toast.fire({
          icon: 'success',
          iconColor: '#ff6900',
          title: 'Documento excluído com sucesso!',
        });
      }
    });
  }, []);

  const handleShow = useCallback(() => {
    setShow(true);
  }, []);

  const handleClickView = useCallback((document) => {
    setShowView(true);
    setNameDoc(document.name);
    setUrlDoc(document.url);
  }, []);

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          description: Yup.string().required('A descrilção é obrigatória'),
          file: Yup.string().when(`$checkFile`, {
            is: (checkFile: boolean) => checkFile,
            then: Yup.string().required('O arquivo é obrigatório'),
            otherwise: Yup.string(),
          }),
        });

        await schema.validate(data, {
          abortEarly: false,
          context: {
            checkFile: files.length === 0,
          },
        });

        const newDocuments: IDocument[] = [];

        for (const file of files) {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('description', data.description);
          formData.append('folder', 'documents');
          formData.append('size', file.size.toString());

          const response = await api.post('archives/admin', formData);
          newDocuments.push({
            id: response.data.id,
            name: response.data.name,
            url: URL.createObjectURL(file),
            date: format(parseISO(response.data.created_at), 'dd/MM/yyyy'),
            description,
            fileSize: file.size.toString(),
          });
        }

        setDocuments((oldState) => [...oldState, ...newDocuments]);

        setFiles([]);
        setShow(false);
        setDescription('');
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Credenciais inválidas!');
        }
      }
    },
    [description, files]
  );

  const handleChangePage = useCallback(
    (page) => {
      if (page <= totalPages) {
        handleLoadFiles(page, filenameData);
        setSelectedPage(page);
      }
    },
    [filenameData, handleLoadFiles, totalPages]
  );

  const handleSubmitFilters = useCallback(
    (formData) => {
      setFilenameData(formData.document);
      handleLoadFiles(1, formData.document);
      setSelectedPage(1);
    },
    [handleLoadFiles]
  );

  const handleClose = useCallback(() => {
    setShow(false);
    setShowView(false);
    setFiles([]);
    setDescription('');
  }, []);

  const handleDeleteColor = useCallback((indexToDelete) => {
    setFiles((prevFiles) =>
      prevFiles.filter((file, index) => index !== indexToDelete)
    );
  }, []);

  const handleDropColor = useCallback(
    (event: React.DragEvent<HTMLLabelElement>) => {
      event.preventDefault();
      const { files: filesData } = event.dataTransfer;
      if (filesData) {
        setFiles(Array.from(filesData));
      }
    },
    []
  );

  const handleDragOver = useCallback(
    (event: React.DragEvent<HTMLLabelElement>) => {
      event.preventDefault();
    },
    []
  );

  const handleChangeFile = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { files: filesData } = event.target;
      if (filesData) {
        setFiles(Array.from(filesData));
      }
    },
    []
  );

  const handleClickPrev = useCallback(() => {
    handleChangePage(selectedPage - 1 <= 1 ? 1 : selectedPage - 1);
  }, [handleChangePage, selectedPage]);

  const handleClickNext = useCallback(() => {
    handleChangePage(
      selectedPage + 1 >= totalPages ? totalPages : selectedPage + 1
    );
  }, [handleChangePage, selectedPage, totalPages]);

  return (
    <Container>
      <div className="container-fluid">
        <div className="row">
          <div className="zoom col-12 px-0">
            <div className="bg-white d-sm-flex justify-content-between align-items-center p-4">
              <h1 className="mb-0">Documentos</h1>
              <button
                type="button"
                onClick={handleShow}
                className="mb-0 me-4 h6 fw-normal text-white btn-new px-4 py-2"
              >
                <HiPlus size={16} color="#fff" className="me-2" />
                Subir documento
              </button>
            </div>
          </div>
          <div className="zoom col-12 px-0">
            <div className="bg-white p-3 mt-3">
              <Filter className="col-12 px-0">
                <FiltersLists document onSubmitFilters={handleSubmitFilters} />
              </Filter>
              <hr className="mt-4 mb-1" />
              <div className="row">
                {documents.map((document) => (
                  <div className="col-12">
                    <div className="columns d-flex align-items-center justify-content-between px-4 py-2 border-bottom">
                      <div className="d-flex align-items-center">
                        <span>
                          <KrUserDocument
                            color="#ff6900"
                            size={24}
                            className="me-3"
                          />
                        </span>
                        <span className="doc-name d-block">
                          {document.name}
                        </span>
                      </div>
                      <div className="">
                        <p className="mb-0 info">
                          <span>Descrição: </span>
                          {document.description}
                        </p>
                      </div>
                      <div className="">
                        <p className="mb-0 info">
                          <span>Data de Upload: </span>
                          {document.date}
                        </p>
                      </div>
                      <div className="">
                        <p className="mb-0 info">
                          <span>Tamanho: </span>
                          {document.fileSize} KB
                        </p>
                      </div>
                      <div>
                        {document.name.toLowerCase().includes('.pdf') ||
                        document.name.toLowerCase().includes('.png') ||
                        document.name.toLowerCase().includes('.jpg') ||
                        document.name.toLowerCase().includes('.jpeg') ? (
                          <button
                            type="button"
                            onClick={() => handleClickView(document)}
                            className="btn-icons border-0 me-2"
                          >
                            <KrEye size={16} color="#fff" />
                          </button>
                        ) : (
                          <a
                            href={document.url}
                            className="btn-icons border-0 me-2"
                            download={document.name}
                            rel="noopener noreferrer"
                          >
                            <IoMdDownload size={16} color="#fff" />
                          </a>
                        )}
                        <button
                          type="button"
                          onClick={() => handleDeleteDocument(document)}
                          className="btn-icons border-0"
                        >
                          <KrTrash size={16} color="#fff" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-12 mt-5">
                  <Pagination className="justify-content-center pt-2 mb-4 mt-3">
                    <div className="d-flex flex-wrap align-items-center justify-content-center">
                      <div className="w-100 w-sm-auto d-flex justify-content-center mt-3 mt-sm-0">
                        <div className="d-flex">
                          <button
                            type="button"
                            className="btn btn-pagination arrow"
                            onClick={handleClickPrev}
                          >
                            <MdOutlineArrowBackIos size={24} color="#a0a0a0" />
                          </button>
                          {pages.map((page, index) => (
                            <button
                              key={index.toString()}
                              type="button"
                              className={`btn btn-pagination ${
                                page ===
                                selectedPage?.toString().padStart(2, '0')
                                  ? 'selected'
                                  : ''
                              } ${page === '...' ? 'ellipsis' : ''}`}
                              onClick={() =>
                                handleChangePage(parseInt(page, 10))
                              }
                              disabled={page === '...'}
                            >
                              {page}
                            </button>
                          ))}
                          <button
                            type="button"
                            className="btn btn-pagination arrow"
                            onClick={handleClickNext}
                          >
                            <MdOutlineArrowForwardIos
                              size={24}
                              color="#a0a0a0"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={show}
        onHide={handleClose}
      >
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Subir novo arquivo</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={handleClose}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12">
                <hr />
              </div>

              <>
                <div className="col-12">
                  <span>Descrição:</span>
                  <Textarea
                    name="description"
                    id="description"
                    value={description}
                    className="w-100 mt-1 description"
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  <label
                    htmlFor="files"
                    className="w-100 label-modal text-center mt-3"
                    onDrop={handleDropColor}
                    onDragOver={handleDragOver}
                  >
                    <MdUpload size={48} color="#FF6900" />
                    <span className="d-block">
                      Arraste e solte o arquivo aqui
                    </span>
                    <span className="d-inline-flex my-2">Selecionar</span>
                    <span className="d-block">
                      Extensões aceitas: pdf, jpg, png, jpeg.
                    </span>
                  </label>
                  <Input
                    id="files"
                    type="file"
                    name="files"
                    className="d-none"
                    onChange={(e) => handleChangeFile(e)}
                  />
                  {files.map((file, index) => (
                    <div
                      // key={index}
                      className="d-flex justify-content-between arquives p-3 mt-3"
                    >
                      <div className="d-flex align-items-center">
                        {file.name.toLowerCase().includes('.pdf') ? (
                          <FaRegFilePdf size={30} color="#8c8c8c" />
                        ) : (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                          />
                        )}
                        <p className="ms-3 mb-0">
                          {file.name}
                          <br />
                          {Math.round(file.size / 1024)} KB
                        </p>
                      </div>
                      <button
                        type="button"
                        className="bg-transparent border-0"
                        onClick={() => handleDeleteColor(index)}
                      >
                        <IoMdClose size={24} color="#8C8C8C" />
                      </button>
                    </div>
                  ))}
                </div>
              </>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 px-5">
            <button
              type="submit"
              disabled={files.length === 0}
              className="mx-auto btn-filter d-flex align-items-center justify-content-center btn h6 fw-normal py-2 px-4 mt-2 mb-0"
            >
              Confirmar Upload
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={showView}
        onHide={handleClose}
      >
        <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
          <Modal.Title className="mb-0 mt-4">
            <h2 className="title mb-0">{nameDoc}</h2>
          </Modal.Title>
          <button
            type="button"
            onClick={handleClose}
            className="border-0 bg-transparent"
          >
            <KrClose size={20} color="#989898" />
          </button>
        </Modal.Header>
        <Modal.Body className="pt-0 px-3 px-sm-5">
          <div className="row">
            <div className="col-12">
              <hr />
            </div>
            <div className="col-12">
              {nameDoc.toLowerCase().includes('.pdf') ? (
                <iframe
                  className="w-100"
                  height={500}
                  title="Comprovante"
                  src={urlDoc}
                  frameBorder="0"
                />
              ) : (
                <img className="w-100 mb-5" src={urlDoc} alt={nameDoc} />
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Withdrawal;
